import React from "react";
import { CheckBox } from "../../../assets";
import VariantManager from "./VariantManager";

export default function VariantsTab({ product, variants, onChange, values }) {
	return <div>
		{/* Product variants */}
		{Boolean(variants) && <div className="variants">
			<div className="padded bordered">
				<h4>Variants</h4>
				<div>
					<br />
						Here you can add variants of this product. This is useful if you want to offer alternate versions.
						<br /><br />
						The variants can have their own prices, names and descriptions.
					</div>
			</div>
			{Boolean(variants.length) && <>
				<div
					className="padded bordered restrict v-middle text-center"
					style={{ cursor: "pointer" }}
					onClick={e => onChange({ restricted: !values.restricted })}
				>
					<CheckBox checked={Boolean(values.restricted)} />
					<b
						className="featureFont"
						style={{ marginLeft: 10, fontSize: "1.3rem" }}
					>Restrict purchase of base product?</b>
				</div>
				<div className="padded bordered">
					If it better suits your use-case, you can restrict purchasing of the base product. Just click the checkbox above as needed.
						<br /><br />
						For example if your base project is "White t-shirt", you might want to restrict it and instead just allow purchasing of the variants "Small", "Medium" and "Large".
					</div>
			</>}
			<VariantManager
				product={product}
				variants={variants}
			/>
		</div>}
	</div>
}